module.exports = __webpack_public_path__ + "img/21_96.48413c1a.png";